import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
    return (
        <>
            {/* Hero Section */}
            <section className="hero" style={{
          background: `linear-gradient(rgba(13, 63, 105, 0.85), rgba(27, 164, 222, 0.85)), url('/images/office_team.png') no-repeat center center/cover`
        }}>
                <div className="container">
                    <h1>Our Services</h1>
                    <p>Comprehensive digital solutions to transform your business and drive growth</p>
                </div>
            </section>

            {/* Services Section - White Background */}
            <section style={{ padding: '80px 0', backgroundColor: 'white' }}>
                <div className="container">
                    <div className="section-title">
                        <h2>Our Services</h2>
                        <p>Transform your ideas into digital reality with our comprehensive development services</p>
                    </div>
                    <div className="services-grid">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-laptop-code"></i>
                            </div>
                            <h3>Web Applications</h3>
                            <p>Scalable, secure, and dynamic web apps that streamline your business operations and empower your team.</p>
                            <ul>
                                <li>Custom CRM & ERP Systems</li>
                                <li>E-commerce Platforms</li>
                                <li>School & Hospital Management Systems</li>
                                <li>Progressive Web Apps (PWAs)</li>
                                <li>Dashboard & Analytics Tools</li>
                                <li>API Development</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-globe"></i>
                            </div>
                            <h3>Websites</h3>
                            <p>Beautiful, responsive, and fast-loading websites that make a powerful first impression and convert visitors into customers.</p>
                            <ul>
                                <li>Corporate Websites</li>
                                <li>E-commerce Sites</li>
                                <li>Portfolio & Business Sites</li>
                                <li>Landing Pages</li>
                                <li>WordPress Development</li>
                                <li>SEO Optimization</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-mobile-alt"></i>
                            </div>
                            <h3>Mobile Applications</h3>
                            <p>Engaging native and cross-platform mobile apps for iOS and Android, designed for the user and built for performance.</p>
                            <ul>
                                <li>Native iOS & Android Apps</li>
                                <li>Cross-Platform Solutions</li>
                                <li>UI/UX Design</li>
                                <li>App Store Deployment</li>
                                <li>Push Notifications</li>
                                <li>App Maintenance</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Additional Services - Light Gray Background */}
            <section style={{ padding: '80px 0', backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="section-title">
                        <h2>Additional Services</h2>
                        <p>Complete digital solutions to support your business growth</p>
                    </div>
                    <div className="services-grid">
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-palette"></i>
                            </div>
                            <h3>UI/UX Design</h3>
                            <p>We craft intuitive and beautiful user interfaces and experiences that engage your audience and drive conversions.</p>
                            <ul>
                                <li>User Research & Analysis</li>
                                <li>Wireframing & Prototyping</li>
                                <li>Visual Design</li>
                                <li>User Testing</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-plug"></i>
                            </div>
                            <h3>API Integration</h3>
                            <p>Connect your software with other services and platforms for extended functionality and seamless workflows.</p>
                            <ul>
                                <li>Third-Party API Integration</li>
                                <li>Payment Gateway Integration</li>
                                <li>Social Media Integration</li>
                                <li>Custom API Development</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <div className="service-icon">
                                <i className="fas fa-tools"></i>
                            </div>
                            <h3>Maintenance & Support</h3>
                            <p>We offer ongoing support and maintenance plans to keep your digital assets secure, up-to-date, and performing optimally.</p>
                            <ul>
                                <li>Regular Updates & Patches</li>
                                <li>Performance Monitoring</li>
                                <li>Security Updates</li>
                                <li>Technical Support</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta">
                <div className="container">
                    <h2>Ready to Start Your Project?</h2>
                    <p>Let's discuss your requirements and create a custom solution that drives your business forward.</p>
                    <Link to="/contact" className="btn">Get Free Consultation</Link>
                </div>
            </section>
        </>
    );
};

export default Services;